import type { Prisma, Subscription } from "@brookbush/database";

export interface Referee {
	id: string;
	firstName: string;
	lastName: string;
	username: string;
	primaryEmailAddress: string;
	createdAt: string;
	updatedAt: string;
	primaryProfessionId: string | null;
	secondaryProfessionId: string | null;
	selectedCertificationId: string | null;
	braintreeCustomerId: string | null;
	stripeCustomerId: string | null;
	externalId: string | null;
	promptedUserActions: any[];
	subscription: Subscription | null;
	imageUrl: string;
}

export type ReferralWithCash = Prisma.ReferralGetPayload<{
	include: {
		cash: true;
	};
}>;

export const LOCALIZED_REFERRAL_PAYOUT_SCHEDULE: {
	[key: string]: {
		total: number; // Total payout in the respective currency's lowest denomination (e.g., cents for USD, paise for INR)
		monthly: {
			initial: number; // Initial monthly payout in the respective currency's lowest denomination
			recurring: number; // Recurring monthly payout in the respective currency's lowest denomination
		};
		yearly: {
			initial: number; // Initial yearly payout in the respective currency's lowest denomination
		};
	};
} = {
	usd: {
		total: 50_00,
		monthly: {
			initial: 20_00,
			recurring: 5_00,
		},
		yearly: {
			initial: 50_00,
		},
	},

	cad: {
		total: 50_00,
		monthly: {
			initial: 20_00,
			recurring: 5_00,
		},
		yearly: {
			initial: 50_00,
		},
	},

	aud: {
		total: 50_00,
		monthly: {
			initial: 20_00,
			recurring: 5_00,
		},
		yearly: {
			initial: 50_00,
		},
	},

	nzd: {
		total: 50_00,
		monthly: {
			initial: 20_00,
			recurring: 5_00,
		},
		yearly: {
			initial: 50_00,
		},
	},

	eur: {
		total: 50_00,
		monthly: {
			initial: 20_00,
			recurring: 5_00,
		},
		yearly: {
			initial: 50_00,
		},
	},

	gbp: {
		total: 50_00,
		monthly: {
			initial: 20_00,
			recurring: 5_00,
		},
		yearly: {
			initial: 50_00,
		},
	},

	aed: {
		total: 45_00,
		monthly: {
			initial: 21_00,
			recurring: 4_00,
		},
		yearly: {
			initial: 45_00,
		},
	},

	sar: {
		total: 45_00,
		monthly: {
			initial: 21_00,
			recurring: 4_00,
		},
		yearly: {
			initial: 45_00,
		},
	},

	pkr: {
		total: 14_00,
		monthly: {
			initial: 5_00,
			recurring: 1_50,
		},
		yearly: {
			initial: 14_00,
		},
	},

	inr: {
		total: 18_00,
		monthly: {
			initial: 6_00,
			recurring: 2_00,
		},
		yearly: {
			initial: 18_00,
		},
	},

	egp: {
		total: 22_00,
		monthly: {
			initial: 7_00,
			recurring: 2_50,
		},
		yearly: {
			initial: 22_00,
		},
	},

	php: {
		total: 26_00,
		monthly: {
			initial: 8_00,
			recurring: 3_00,
		},
		yearly: {
			initial: 26_00,
		},
	},
};

export type ReferralExpanded = Prisma.ReferralGetPayload<{
	include: {
		referee: {
			include: {
				subscription: true;
			};
		};
	};
}> & {
	referee: Referee & {
		imageUrl: string;
	};
};
